module.exports = __webpack_public_path__ + "img/19.d620f466.jpg";